import type { SeasonEntity, SeasonEntityResources } from "~types/seasonEntity";
import type { SeasonEntityTransformed } from "../types/seasonEntityTransformed";
import { transformSeasonEntity } from "./transformSeasonEntity";

export const transformSeasonEntities = (items: SeasonEntity[], resources: SeasonEntityResources | undefined): SeasonEntityTransformed[] =>
  items.map((item) => transformSeasonEntity(item, resources));
